/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { Policy, Policy$Outbound, Policy$outboundSchema } from "./policy.js";

export type V1GatewaySetPoliciesRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * The environment's complete policy list, in evaluation order. Every call
   *
   * @remarks
   * replaces all stored policies with exactly this list; an empty list
   * removes every policy. The operation is atomic: if any policy is
   * invalid, nothing is written. An environment can hold at most 50
   * policies.
   */
  policies: Array<Policy>;
};

/** @internal */
export type V1GatewaySetPoliciesRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
  policies: Array<Policy$Outbound>;
};

/** @internal */
export const V1GatewaySetPoliciesRequestBody$outboundSchema: z.ZodType<
  V1GatewaySetPoliciesRequestBody$Outbound,
  z.ZodTypeDef,
  V1GatewaySetPoliciesRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
  environment: z.string(),
  policies: z.array(Policy$outboundSchema),
});

export function v1GatewaySetPoliciesRequestBodyToJSON(
  v1GatewaySetPoliciesRequestBody: V1GatewaySetPoliciesRequestBody,
): string {
  return JSON.stringify(
    V1GatewaySetPoliciesRequestBody$outboundSchema.parse(
      v1GatewaySetPoliciesRequestBody,
    ),
  );
}
